import { Stack, Text } from '@mantine/core';
import { Panel } from 'components/Panel';
import { i18nKeys } from 'locales';
import { useTranslation } from 'locales/logic';
import { isEmpty } from 'remeda';
import type { Task } from 'shared/hooks/use-load-tasks';
import { TaskItem } from './TaskItem';

type TaskListPanelProps = {
  tasks: Array<Task>;
  variant: 'todo' | 'completed' | 'ignored';
};

export const TaskListPanel = ({ tasks, variant }: TaskListPanelProps) => {
  const { t } = useTranslation();

  if (isEmpty(tasks))
    return (
      <Text c="dimmed" ta="center" py="xl">
        {t(EMPTY_STATE_KEYS[variant])}
      </Text>
    );

  return (
    <Panel flushContent>
      <Stack gap={0}>
        {tasks.map(task => (
          <TaskItem key={task.id} task={task} />
        ))}
      </Stack>
    </Panel>
  );
};

const EMPTY_STATE_KEYS = {
  todo: i18nKeys.TASK.EMPTY_STATE.NO_PENDING_TASKS,
  completed: i18nKeys.TASK.EMPTY_STATE.NO_COMPLETED_TASKS,
  ignored: i18nKeys.TASK.EMPTY_STATE.NO_IGNORED_TASKS,
} as const;
